import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from '../../shared/commonGrid/grid-enums';
import { stringArrayComparator } from '../../shared/commonGrid/grid-util';

export default [
  {
    headerName: '',
    field: COMMON_GRID_COLUMN_FIELD_NAMES.Action,
    cellRenderer: 'actionMenuCellRenderer',
  },
  {
    headerName: i18n.t('role.grid.name'),
    field: 'name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'name',
  },
  {
    headerName: i18n.t('role.grid.description'),
    field: 'description',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'description',
  },
  {
    headerName: i18n.t('role.grid.permissions'),
    field: 'permissionLabels',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    tooltipField: 'permissionLabels',
    resizable: true,
    filterParams: { textCustomComparator: stringArrayComparator },
  },
];
